// extracted by mini-css-extract-plugin
export default {"container":"yDmqO","list":"IT6ZC","event":"dXNdp","title":"_4gy+w","chevron":"dhmax","info":"ZRJqh","time":"qXkrD"};